import React from 'react';
import { Box } from '@mui/material';
import OTPVerification from '../components/OTPVerification';

interface OTPVerificationPageProps {
  email: string;
  onVerify: (otp: string) => void;
  onResend: () => void;
  onChangeEmail: () => void;
}

const OTPVerificationPage: React.FC<OTPVerificationPageProps> = ({
  email,
  onVerify,
  onResend,
  onChangeEmail
}) => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: '#FBF9F6',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        py: 2
      }}
    >
      <OTPVerification
        email={email}
        onVerify={onVerify}
        onResend={onResend}
        onChangeEmail={onChangeEmail}
      />
    </Box>
  );
};

export default OTPVerificationPage;
